import axios from '../../../axios';
import NoteDTO from '../types/NoteDTO';

const url = 'invoicingservice/api/invoice-note';

export const getAllNotesForInvoice = (invoiceId: string) =>
  axios.get(`${url}?invoiceId=${invoiceId}`);
export const createInvoiceNote = (note: NoteDTO) => axios.post(url, note);
export const updateInvoiceNote = (note: NoteDTO) => axios.put(url, note);
export const archiveInvoiceNote = (id: string) => axios.post(`${url}/markArchived?id=${id}`);
